module.exports = __webpack_public_path__ + "img/dragons_hero.746647f1.webp";